import { createFileRoute } from '@tanstack/react-router';
import {
  Alert,
  Button,
  Card,
  Container,
  Group,
  Select,
  Stack,
  Text,
  Textarea,
  TextInput,
  Title,
} from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { motion } from 'framer-motion';
import { useState } from 'react';
import { trpc } from '../lib/trpc';
import { PublicShell } from '../components/PublicShell';

function ContactPage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [topic, setTopic] = useState<string | null>('Sales');
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);

  const submit = trpc.public.contact.submit.useMutation({
    onSuccess: () => {
      setSent(true);
      notifications.show({ message: 'Message received — we will get back to you', color: 'green' });
    },
    onError: (err) => notifications.show({ message: err.message, color: 'red' }),
  });

  return (
    <PublicShell>
      <Container size="sm" py="xl">
        <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}>
          <Stack gap="md">
            <Title order={2}>Contact us</Title>
            <Text c="dimmed">
              Sales, partnerships, or platform questions — drop a note and we'll reply within one
              business day.
            </Text>

            <Card>
              {sent ? (
                <Alert color="green">
                  Thanks — your message is in the queue. We'll reply to <strong>{email}</strong>{' '}
                  shortly.
                </Alert>
              ) : (
                <Stack>
                  <Group grow>
                    <TextInput
                      label="Name"
                      required
                      value={name}
                      onChange={(e) => setName(e.currentTarget.value)}
                    />
                    <TextInput
                      label="Email"
                      type="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.currentTarget.value)}
                    />
                  </Group>
                  <Select
                    label="Topic"
                    data={['Sales', 'Support', 'Partnership', 'Press', 'Other']}
                    value={topic}
                    onChange={setTopic}
                  />
                  <Textarea
                    label="Message"
                    required
                    autosize
                    minRows={4}
                    maxRows={10}
                    value={message}
                    onChange={(e) => setMessage(e.currentTarget.value)}
                  />
                  <Group justify="end">
                    <Button
                      loading={submit.isPending}
                      disabled={!name || !email || message.length < 5}
                      onClick={() =>
                        submit.mutate({
                          name,
                          email,
                          topic: topic ?? undefined,
                          message,
                        })
                      }
                    >
                      Send
                    </Button>
                  </Group>
                </Stack>
              )}
            </Card>
          </Stack>
        </motion.div>
      </Container>
    </PublicShell>
  );
}

export const Route = createFileRoute('/contact')({ component: ContactPage });
